"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "slot", {
    enumerable: true,
    get: function() {
        return _slot;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _slot = /*#__PURE__*/ _interop_require_wildcard._(require("./slot"));
_export_star._(require("./types"), exports);
_export_star._(require("./isResolvedShorthand"), exports);
_export_star._(require("./constants"), exports);
_export_star._(require("./isSlot"), exports);
_export_star._(require("./assertSlots"), exports);
_export_star._(require("./getIntrinsicElementProps"), exports);
_export_star._(require("./deprecated/getSlots"), exports);
_export_star._(require("./deprecated/resolveShorthand"), exports);
_export_star._(require("./deprecated/getSlotsNext"), exports);
